module.exports = __webpack_public_path__ + "static/media/Redux.8251fe76.png";